// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 842 ? "06ed8259" : chunkId) + "." + {"28":"6d5eb7122e74880d","544":"6e04cc0cd479cd34","711":"3b792ae7153f0d54","842":"7aa4aba3f9eb6bfa"}[chunkId] + ".js";
};